module.exports = __webpack_public_path__ + "img/ico-portfolio.9709c971.svg";